export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["OnlineCheckIn"] = "OnlineCheckIn";
    OrderStatus["WaitPayment"] = "WaitPayment";
    OrderStatus["Confirmed"] = "Confirmed";
})(OrderStatus || (OrderStatus = {}));
